import axios from "axios";

// Requests never throw: callers get { statusCode, responsePayload, errors }.
// The API replies with { message, errors? }; older endpoints used responsePayload.
const shape = (status, data = {}) => ({
  statusCode: status,
  responsePayload: data.responsePayload ?? data.message,
  errors: data.errors,
});

const axiosPost = async (url, payload) => {
  try {
    const response = await axios.post(url, payload, { timeout: 30000 });
    return shape(response.status, response.data);
  } catch (error) {
    return handleAxiosError(error);
  }
};

const axiosFileUploadPost = async (url, payload) => {
  try {
    const response = await axios.post(url, payload, {
      timeout: 60000,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return shape(response.status, response.data);
  } catch (error) {
    return handleAxiosError(error);
  }
};

const handleAxiosError = (error) => {
  if (error.response) {
    const data = error.response.data || {};
    return {
      ...shape(error.response.status, data),
      responsePayload: data.responsePayload ?? data.message ?? "An error occurred",
    };
  }
  if (error.request) {
    return {
      statusCode: 0,
      responsePayload: "Network error: Please check your connection",
    };
  }
  return {
    statusCode: 0,
    responsePayload: "An unexpected error occurred",
  };
};

export { axiosPost, axiosFileUploadPost };
